import React, { useEffect } from "react";
import env from '.env.json';
declare let window: any;

const GoogleAdsense = ({ width, height, dataSlot, dataFormat, className = '' }: any) => {
  return <></>
  // useEffect(() => {
  //   loadAds();
  // }, []);

  // const loadAds = () => {
  //   try {
  //     if (typeof window !== "undefined" && env.ENV === 'prod') {
  //       (window.adsbygoogle = window.adsbygoogle || []).push({});
  //     }
  //   } catch (error) {
  //     console.log("adsense error", error.message);
  //   }
  // };

  // let styles = { display: "block" };
  // if (width) styles['width'] = width;
  // if (height) styles['height'] = height;

  // return (
  //   <>
  //     <center className={`${className} ${env.ENV == 'dev' ? 'bg-info cursor-pointer' : ''}`}
  //       style={{ overflow: width == '100%' ? 'inherit' : 'auto', overflowY: 'hidden' }}
  //     >
  //       <ins
  //         className="adsbygoogle"
  //         style={styles}
  //         data-ad-client="ca-pub-6227354697192631"
  //         data-ad-slot={dataSlot}
  //         data-ad-format={dataFormat || 'auto'}
  //         data-full-width-responsive="true">
  //       </ins>
  //     </center>
  //     <style jsx global>{`
  //       ins.adsbygoogle[data-ad-status="unfilled"] {
  //         display: none !important;
  //       }
  //     `}
  //     </style>
  //   </>
  // )
}

export default GoogleAdsense;
